import { useState, useEffect } from 'react'

export const useCharacters = () => {
  // 當前選中的角色
  const [currentCharacter, setCurrentCharacter] = useState(() => {
    try {
      const saved = localStorage.getItem('beat-buddy-current-character')
      return saved || 'unicorn'
    } catch (error) {
      return 'unicorn'
    }
  })

  // 當前顏色
  const [currentColor, setCurrentColor] = useState(() => {
    try {
      const saved = localStorage.getItem('beat-buddy-current-color')
      return saved || '#5D5CDE'
    } catch (error) {
      return '#5D5CDE'
    }
  })

  // 當前配件
  const [currentAccessory, setCurrentAccessory] = useState(() => {
    try {
      const saved = localStorage.getItem('beat-buddy-current-accessory')
      return saved || 'none'
    } catch (error) {
      return 'none'
    }
  })

  // 已解鎖的角色列表 - 只包含獨角獸
  const [unlockedCharacters, setUnlockedCharacters] = useState(() => {
    try {
      const saved = localStorage.getItem('beat-buddy-unlocked-characters')
      if (saved) {
        return JSON.parse(saved)
      }
    } catch (error) {
      console.error('Error loading unlocked characters:', error)
    }
    return ['unicorn'] // 默認只有獨角獸
  })

  // 角色默認顏色
  const characterColors = {
    unicorn: '#5D5CDE',
    dragon: '#FFB677',
    panda: '#FFDE59',
    fox: '#FF8E8E',
    alien: '#61DAFB',
    robot: '#88EFDD',
    wizard: '#D4B3FF',
    ninja: '#5E17EB',
    princess: '#FFAAD4',
    superhero: '#FFDE59'
  }

  // 保存到 localStorage
  useEffect(() => {
    try {
      localStorage.setItem('beat-buddy-current-character', currentCharacter)
    } catch (error) {
      console.error('Error saving current character:', error)
    }
  }, [currentCharacter])

  useEffect(() => {
    try {
      localStorage.setItem('beat-buddy-current-color', currentColor)
    } catch (error) {
      console.error('Error saving current color:', error)
    }
  }, [currentColor])

  useEffect(() => {
    try {
      localStorage.setItem('beat-buddy-current-accessory', currentAccessory)
    } catch (error) {
      console.error('Error saving current accessory:', error)
    }
  }, [currentAccessory])

  // 保存解鎖的角色
  useEffect(() => {
    try {
      localStorage.setItem('beat-buddy-unlocked-characters', JSON.stringify(unlockedCharacters))
      console.log(`💾 Saved unlocked characters: [${unlockedCharacters.join(',')}]`)
    } catch (error) {
      console.error('Error saving unlocked characters:', error)
    }
  }, [unlockedCharacters])

  // 解鎖新角色
  const unlockCharacter = (characterId) => {
    console.log(`🔓 Trying to unlock character: ${characterId}`)
    setUnlockedCharacters(prev => {
      if (prev.includes(characterId)) {
        console.log(`Character ${characterId} already unlocked`)
        return prev
      }
      const newList = [...prev, characterId]
      console.log(`✅ Character ${characterId} unlocked! New list: [${newList.join(',')}]`)
      return newList
    })
  }

  return {
    currentCharacter,
    currentColor,
    currentAccessory,
    characterColors,
    unlockedCharacters,
    setCurrentCharacter,
    setCurrentColor,
    setCurrentAccessory,
    unlockCharacter
  }
}